import { createI18n, LocaleMessages, VueMessageType } from "vue-i18n";
import { mergeDeep } from "@/core/utils";
import config from "../../images/configuration.json";

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages(): any {
  let locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages: LocaleMessages<VueMessageType> = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default;
    }
  });

  locales = require.context("../../images/locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = mergeDeep(messages[locale], locales(key));
    }
  });
  return messages;
}

const numberFormats = {
  en: {
    number: {
      useGrouping: true,
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    },
    decimalac: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
  fr: {
    number: {
      useGrouping: true,
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    },
    decimalac: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
  swe: {
    number: {
      useGrouping: true,
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    },
    decimalac: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
  it: {
    number: {
      useGrouping: true,
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 1,
    },
    decimalac: {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    },
  },
};

export default createI18n({
  legacy: false,
  globalInjection: true,
  numberFormats,
  locale: config.locale.primary || "en",
  fallbackLocale: config.locale.fallback || "en",
  formatFallbackMessages: true,
  messages: loadLocaleMessages(),
  fallbackWarn: false,
  missingWarn: false,
});
